export enum OnyxMapMode {
  MINIMIZED,
  MAXIMIZED,
}
